export default "__VITE_ASSET__eQ_GGgXZ__"